import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { max: Number, dynamicMax: Boolean }

  connect() {
    const input = this.element.querySelector("input[type=number]")
    const range = this.element.querySelector("input[type=range]")

    if (!this.dynamicMaxValue) {
      input.max = this.maxValue
      range.max = this.maxValue
      return
    }

    if (input.value > this.maxValue) {
      range.max = input.value
    } else {
      range.max = this.maxValue
    }

    input.addEventListener("input", () => {
      if (input.value > this.maxValue) {
        range.max = input.value
      }
    })
  }
}
